import script from "./ReportPagePractice.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportPagePractice.vue?vue&type=script&setup=true&lang=js"

import "./ReportPagePractice.vue?vue&type=style&index=0&id=ee8b39e2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee8b39e2"]])

export default __exports__